var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMissedCallIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75393 9.24599C5.97393 8.46599 5.38593 7.59266 4.99527 6.70666C4.91327 6.51932 4.96127 6.29999 5.10593 6.15532L5.65193 5.60932C6.09927 5.16199 6.09927 4.52932 5.7086 4.13866L4.9266 3.35666C4.40593 2.83599 3.56194 2.83599 3.04127 3.35666L2.6066 3.79066C2.1126 4.28466 1.9066 4.99732 2.03994 5.70399C2.36927 7.44599 3.38127 9.35332 5.01393 10.986C6.6466 12.6187 8.55393 13.6307 10.2959 13.96C11.0026 14.0933 11.7153 13.8873 12.2093 13.3933L12.6433 12.9593C13.1639 12.4387 13.1639 11.5947 12.6433 11.074L11.8613 10.292C11.4706 9.90132 10.8373 9.90132 10.4473 10.292L9.84527 10.8947C9.7006 11.0393 9.48127 11.088 9.29393 11.0053C8.40793 10.614 7.53393 10.0253 6.75393 9.24599Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6V2H10",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6L14 2",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMissedCallIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/MissedCallIcon.69d93001.svg";
export { ForwardRef as ReactComponent };